export default class SelectStyle {
  constructor(selector) {
    this.select = document.querySelector(selector); // 指定されたセレクタで要素を取得

    // 要素が見つからない場合は処理を中断
    if (!this.select) return;

    // 初期処理を実行
    this.applyInitialStyle();

    // イベントリスナーを登録
    this.bindEvents();
  }

  // 初期値のスタイルを適用するメソッド
  applyInitialStyle() {
    if (this.select.selectedIndex === 0) {
      this.select.classList.add('is-first'); // 初期値の文字色
    } else {
      this.select.classList.remove('is-first'); // 通常の文字色
    }
  }

  // イベントをバインドするメソッド
  bindEvents() {
    this.select.addEventListener('change', () => this.applyInitialStyle());
  }
}
